/**
 * https://isotope.metafizzy.co/
 *
 * init isotope with data-attribute on parent Element
 * teh value muss be a valid child selector
 * f.e. data-init-isotope=".grid"
 *
 *
 * next Steps TODO
 * pagination with simple setting of filters
 * f.e. 40 items with 10 per page. = generate pagination with 4 pages and set items to filter class with pagenumber
 *
 */
import Isotope from 'isotope-layout';

let isotope = {

    init: function () {
        isotope.ACTIVECLASS = 'iso-active';


        const isotopeSelector = '[data-element-isotope]';
        isotope.elements = document.querySelectorAll(isotopeSelector);
        isotope.attemptActionIfNotEmpty(isotope.ready);

        window.addEventListener('load', () => {
            isotope.attemptActionIfNotEmpty(isotope.loaded);
        });

        return isotope;
    },

    attemptActionIfNotEmpty: function (action) {
        if (isotope.elements && isotope.elements.length > 0) {
            action();
        }
    },

    ready: function () {
        const removeActiveClassFromAllTags = (tags) => tags.forEach(tag => tag.classList.remove('active'));
        isotope.elements.forEach(item => {
            item.classList.add('isotope-container');
            isotope.setActiveClass();

            isotope.iso = new Isotope('.isotope-container', {
                layoutMode: 'fitRows',
                gutter: 0,
                fitRows: {
                    equalheight: true
                }
            });

            const filters = document.querySelectorAll('[data-filter]');

            filters.forEach(button => {
                button.addEventListener('click', function () {
                    let filter = button.getAttribute('data-filter');

                    isotope.elements.forEach(item => {
                        isotope.removeActiveClasses(item);
                    });

                    //filter = filter + '.id-0-1-konferenz';
                    isotope.setActiveClass(filter);

                    isotope.iso.arrange({filter: filter});
                    removeActiveClassFromAllTags(filters);
                    button.classList.add('active');
                });
            });
        });

    },

    removeActiveClasses: function (parent) {
        for (const child of parent.children) {
            child.classList.remove(isotope.ACTIVECLASS);
        }
    },

    setActiveClass: function (filter = '.isotope-container > *') {
        const el = document.querySelectorAll(filter);
        el.forEach(item => {
            item.classList.add(isotope.ACTIVECLASS);
        });
    },

    loaded: function () {
        isotope.iso.reloadItems();
    }
};


export default isotope.init();



